import React from "react";

export const TimeIcon = () =>{
    return(
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
  <path id="icons8-time" d="M11,4a7,7,0,1,0,7,7A7.021,7.021,0,0,0,11,4Zm2.625,8.05h-2.8a.538.538,0,0,1-.525-.525v-4.2a.525.525,0,1,1,1.05,0V11h2.275a.525.525,0,0,1,0,1.05Z" transform="translate(-4 -4)" fill="#ced3dd"/>
</svg>

    )
}